import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/shared/utils/cn';
import { fieldBoxClass, fieldInnerClass } from './fieldStyles';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  wrapperClassName?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, wrapperClassName, disabled, rows = 4, ...rest },
  ref,
) {
  return (
    <div
      className={cn(fieldBoxClass, 'items-start py-3', wrapperClassName)}
      data-invalid={invalid ? 'true' : undefined}
      data-disabled={disabled ? 'true' : undefined}
    >
      <textarea
        ref={ref}
        rows={rows}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        className={cn(fieldInnerClass, 'resize-y', className)}
        {...rest}
      />
    </div>
  );
});
